import * as React from 'react';
import { css, styled } from 'styled-components';
import AlertMessage from '../../components/AlertMessage/AlertMessage';
import { mqLarge } from '../../styles/media-query';

export interface FlagProps extends React.ComponentProps<typeof AlertMessage> {
  open: boolean;
  dismissTimeout?: number;
}

const Flag: React.FC<FlagProps> = ({
  open,
  dismissTimeout = 0,
  onDismiss,
  ...alertProps
}) => {
  React.useEffect(() => {
    if (open && dismissTimeout && onDismiss) {
      const timeoutId = setTimeout(() => {
        onDismiss();
      }, dismissTimeout);
      return () => clearTimeout(timeoutId);
    }
  }, [dismissTimeout, onDismiss, open]);

  return (
    <Wrapper $open={open}>
      <AlertMessage onDismiss={onDismiss} {...alertProps} />
    </Wrapper>
  );
};

const Wrapper = styled.div<{ $open: boolean }>`
  position: fixed;
  left: var(--space-1);
  right: var(--space-1);
  bottom: var(--space-1);
  z-index: var(--z-index-10);
  @media ${mqLarge} {
    bottom: var(--space-4);
    left: var(--space-4);
    right: auto;
  }

  transform: translate3d(0, 3rem, 0);
  opacity: 0;
  transition:
    opacity 250ms ease-in-out,
    transform 250ms ease-in-out;

  ${({ $open }) =>
    $open &&
    css`
      transform: translate3d(0, 0, 0);
      opacity: 1;
    `}
`;

export default Flag;
